// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","brand":"src-components-Footer----footer-module---brand---1NGB8","links":"src-components-Footer----footer-module---links---EXm1s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.scss
// module id = 301
// module chunks = 114276838955818